import { Link } from "react-router-dom";
import "../components/categories.css";

const accessoires = [

  {
    name: "Swaddles & Blankets",
    path: "/category/Accessories/Swaddles%20%26%20Blankets",
    image:
      "https://i.postimg.cc/g2pczf6J/Swaddles-blankets-(2).jpg"
  },

  {
    name: "Hats",
    path: "/category/Accessories/Hats",
    image:
      "https://i.postimg.cc/mkMRRwL7/Hats-(2).jpg"
  },

  {
    name: "Socks & Tights",
    path: "/category/Accessories/Socks%20%26%20Tights",
    image:
      "https://i.postimg.cc/RZv95Kj3/Soks-tights.jpg"
  },

  {
    name: "Hair Accessories",
    path: "/category/Accessories/Hair",
    image:
      "https://i.postimg.cc/ZY3hWwmB/Hair-(2).jpg"
  },

  {
    name: "Washcloths",
    path: "/category/Accessories/Washcloths",
    image:
      "https://i.postimg.cc/pLVN1xFB/Washcloths-(2).jpg"
  },

  {
    name: "Gloves",
    path: "/category/Accessories/Gloves",
    image:
      "https://i.postimg.cc/KctdG47m/Glovs.jpg"
  }

];


function Accessoires() {

  return (

    <section className="categories-section">

      <h2 className="categories-title">
        Accessories
      </h2>


      <div className="categories">

        {accessoires.map(cat => (

          <Link
            to={cat.path}
            className="category-card"
            key={cat.name}
          >

            <img
              src={cat.image}
              alt={cat.name}
            />

            <h3>
              {cat.name}
            </h3>

          </Link>

        ))}

      </div>

    </section>

  );

}


export default Accessoires;